<template>
  <div class="header-top">
    <div class="head-content">
      <div class="head-mid clearfix">
        <img :src="portalLogo" class="logo" v-if="portalLogo">
        <img src="@/assets/XunwLogo.png" class="logo" v-else>
        <!-- <span class="ptname">| &nbsp;成人教育管理平台</span> -->
        <div class="xzli qr-hover" @mouseover="show_qr">
          <img src="@/assets/home_icon02.png" class="ticon">微信扫码访问
          <div class="qrcode" ref="qr_code">
            <img src="/wx-mp.png" style="width: 120px;height: 120px;">
            <!-- <vue-qr :text="h5Url" :margin="5" colorDark="#000" colorLight="#fff" :logoScale="0.3" :size="90"></vue-qr> -->
          </div>
        </div>
        <div class="xzli" @click="goAdmin">
					<img src="@/assets/desktop.png" class="ticon">
          <span>成人教育管理平台</span>
				</div>
        <div class="xzli" v-b-modal.LoginForm v-if="!is_login">
					<img src="@/assets/home_icon17.png" class="ticon">
          <span>登录</span>
				</div>
      </div>
    </div>
    <div class="nav" id="adult-style">
      <div class="nav-mid">
        <el-menu :default-active="activeIndex" class="el-menu clearfix" mode="horizontal" text-color="#FFF" :router="router">
          <el-menu-item class="el-menu-item" index="Login">首页</el-menu-item>
          <el-menu-item class="el-menu-item" index="News">新闻资讯</el-menu-item>
          <!-- <el-menu-item class="el-menu-item" index="Download">APP下载</el-menu-item> -->
          <el-menu-item class="el-menu-item" index="Help">帮助中心</el-menu-item>
          <el-menu-item class="el-menu-item adult" index="Adult">
            <div></div>
            <div>备战成人高考</div>
            <div></div>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
		<login-form ref="LoginForm"></login-form>
  </div>
</template>

<script>
import LoginForm from "@/components/LoginForm.vue";
import vueQr from "vue-qr";
export default {
    components: {
    vueQr,
    LoginForm,
  },
  props: {
    activeIndex: {
      type: String,
      default: 'Login'
    },
    is_login: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      router: true,
      h5Url: `${window.location.protocol}//${window.location.hostname}/h5`,
      portalLogo: '',
      tenantDomain: '',
    }
  },
  created () {
    this.getTenant()
  },
  methods: {
    getTenant () {
      this.axios.get("/student/base/tenant/list").then(res => {
        if (res.data.data && res.data.data.length>0) {
          let data = res.data.data[0]
          this.portalLogo = data.photo || data.portalLogo
          this.tenantDomain = data.tenantDomain
        }
      }).catch((error) => {
        console.log('error:',error);
      })
    },
    ensureHttpPrefix(url) {
      if (!/^https?:\/\//.test(url) || /^http:\/\//.test(url)) {
        url = "https://" + url.replace(/^http:\/\//, '');
      }
      return url;
    },
    goAdmin(){
      if (this.tenantDomain) {
        window.open(this.ensureHttpPrefix(this.tenantDomain))
      } else {
        window.open(process.env.VUE_APP_MANAGEMENT_SYSTEM)
      }
    },
    show_qr() {
      if (this.$refs.qr_code.style.display=='block') {
        this.$refs.qr_code.style.display='none'
      } else {
        this.$refs.qr_code.style.display='block'
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.navbar-brand {
  color: #093151;
  font-size: 1.5rem;
}
.header-top {
  background-color: #f5f5f5;
  position: relative;
  .head-content {
    background: url("../assets/home_icon01.png") no-repeat;
    background-size: 100%;
    .head-mid {
      width: 1200px;
      margin: 0 auto;
      .logo {
        float: left;
        height: 3.5rem;
        margin: 22px 20px 0 0;
      }
      .ptname {
        float: left;
        font-size: 24px;
        color: #093151;
        line-height: 100px;
        display: block;
      }
      .xzli {
        float: right;
        font-size: 16px;
        color: #333333;
        line-height: 30px;
        margin: 35px 0 35px 50px;
        cursor: pointer;
        position: relative;
        .ticon {
          display: inline-block;
          vertical-align: middle;
          margin-bottom: 2px;
          margin-right: 5px;
        }
        .qrcode {
          display: none;
          position: absolute;
          top: 35px;
          right: -12px;
          z-index: 2;
        }
      }
    }
  }
  .nav {
    width: 100%;
    background-color: rgba(25, 101, 162, 0.6);
    position: absolute;
    top: 100px;
    left: 0;
    z-index: 1;
    .nav-mid {
      width: 1200px;
      margin: 0 auto;
      background: transparent;
      .el-menu {
        background: transparent;
        border-bottom: none;
        .el-menu-item {
          width: 150px;
          text-align: center;
        }
        .el-menu-item:hover {
          background: transparent;
        }
        .el-menu-item.is-active {
          border-bottom: none;
          color: #1965a2;
          background-color: #eef6ff;
        }
        .adult {
          display: flex;
          padding: 0;
          width: 276px;
          border: none;
          font-size: 26px;
          font-weight: bold;
          margin-left: 60px;
          :nth-child(1) {
            width: 60px;
            background: linear-gradient(-45deg, #ffa400 50%, transparent 50%);
          }
          :nth-child(2) {
            background-color: #ffa400;
          }
          :nth-child(3) {
            width: 60px;
            background: linear-gradient(135deg, #ffa400 50%, transparent 50%);
          }
        }
      }
    }
  }
}
</style>